import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { MainButton } from '@/components/ui/Button/Button';
import { selectActiveBlitzContractStep } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { useCompleteSpecContact } from './complete-spec-contract.hook';

interface CompleteSpecContractButtonProps {
  kind: SpecContractType | PaidSpecContractType;
}

const CompleteSpecContractButton: FC<CompleteSpecContractButtonProps> = ({
  kind,
}) => {
  const { t } = useTranslation();
  const buttonProps = useCompleteSpecContact(kind);
  const freeBlitzActiveStep = useAppSelector((state) =>
    selectActiveBlitzContractStep(state, 'Blitz'),
  );

  const paidBlitzActiveStep = useAppSelector((state) =>
    selectActiveBlitzContractStep(state, 'BlitzPlus'),
  );

  const getBlitzText = (): string => {
    if (kind === 'Blitz') {
      return ` ${freeBlitzActiveStep}/4`;
    }

    if (kind === 'BlitzPlus') {
      return ` ${paidBlitzActiveStep}/4`;
    } else {
      return '';
    }
  };

  return (
    <MainButton
      {...buttonProps}
      text={t('Complete') + getBlitzText()}
      className="mx-4 !w-[calc(100%_-_2rem)] mb-4"
    />
  );
};

export { CompleteSpecContractButton };
